import React, { useCallback } from 'react';
import { _ } from '@splunk/ui-utils/i18n';
import ArrowsCircularDouble from '@splunk/react-icons/ArrowsCircularDouble';
import { ActionButton, useActionButtonClick } from '../ActionButton';
import type { BaseButtonProps } from '../BaseButton';
import { getButtonTitle } from '../utils/getButtonTitle';

const refreshIcon = <ArrowsCircularDouble />;

export const RefreshButton = ({
    itemId,
    dashboardApi,
    screenReaderText,
    itemDefinition,
    ...rest
}: BaseButtonProps): JSX.Element | null => {
    const refreshVisualization = useCallback(() => {
        if (typeof itemId !== 'string') {
            return;
        }
        // dashboardApi and itemId have to exist to execute this callback
        dashboardApi?.refreshVisualization(itemId);
    }, [dashboardApi, itemId]);

    const handleOnClick = useActionButtonClick('refresh', refreshVisualization);

    const buttonTitle = getButtonTitle({
        base: _('Refresh'),
        screenReaderText,
    });

    if (
        itemId == null ||
        dashboardApi == null ||
        !itemDefinition?.dataSources?.primary
    ) {
        return null;
    }
    return (
        <ActionButton
            {...rest}
            data-test="refresh-button"
            onClick={handleOnClick}
            icon={refreshIcon}
            title={buttonTitle}
        />
    );
};
